<div class="content-option-row">
  <div class="content-option-row-label" translate>Every</div>
  <rotec-number-input-panel-v2
    class="number-input-panel"
    [darkMode]="true"
    [min]="1"
    [value]="interval"
    (valueChange)="intervalChange($event)"
  ></rotec-number-input-panel-v2>
  <div class="label-spacing" translate>Month(s)</div>
</div>

<div class="content-option-row margin-top-20">
  <div class="content-select">
    <rotec-radio-group-v2
      [darkMode]="true"
      [options]="isIntervalExactItems"
      [selected]="isIntervalExact"
      (selectedChange)="isIntervalExactChange($event)"
    ></rotec-radio-group-v2>
  </div>
  @if (isIntervalExact) {
    <div class="content-option-row">
      <rotec-number-input-panel-v2
        class="number-input-panel"
        [darkMode]="true"
        [min]="1"
        [max]="31"
        [value]="dayOfMonth"
        (valueChange)="dayOfMonthChange($event)"
      ></rotec-number-input-panel-v2>
      <div class="label-spacing" translate>. day of the Month</div>
    </div>
  }
  @if (!isIntervalExact) {
    <div class="content-option-row">
      <rotec-select-v2
        class="interval-weeks-select"
        [darkMode]="true"
        [secondary]="true"
        [items]="weekOfMonthOptions"
        [selectedItem]="weekOfMonth"
        (selectedItemChange)="weekOfMonthChange($event)"
      ></rotec-select-v2>
      <div class="content-option-row-label">&nbsp;</div>
      <rotec-select-v2
        class="day-select"
        [darkMode]="true"
        [secondary]="true"
        [items]="dayOfWeekOptions"
        [selectedItem]="dayOfWeek"
        (selectedItemChange)="dayOfWeekChange($event)"
      ></rotec-select-v2>
    </div>
  }
</div>
